import { PaginationValues } from "../../types/General/PaginationValues";
import { IndicatorDataReportAnalyics } from "../../types/Indicator/IndicatorDataReport/IndicatorDataReportAnalyics";
import api from "../../utils/api";
import { INDICATOR_ANALYTICS_URL } from "../../utils/endpoints";

export async function getIndicatorAnalytics(
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    if (!filterValues.IndicatorLevelId || !filterValues.IndicatorId) {
      return { content: [], totalItems: 0 };
    }
    const response = await api.get(`${INDICATOR_ANALYTICS_URL}`, {
      params: {
        ...filterValues,
        ...paginationValues,
      },
    });

    const data: IndicatorDataReportAnalyics[] = response.data.value.result.map(
      (option: IndicatorDataReportAnalyics) => ({
        indicator: option.indicator,
        reference: option.reference ?? null,
        currentValue: option.currentValue ?? null,
        lastValue: option.lastValue ?? null,
        lastLastValue: option.lastLastValue ?? null,
        lastYearValue: option.lastYearValue ?? null,
        currentWithPrevious: option.currentWithPrevious ?? null,
        currentWithPreviousYear: option.currentWithPreviousYear ?? null,
        state: option.state ?? null,
        county: option.county ?? null,
        province: option.province ?? null,
        frequency: option.frequency ?? null,
      }),
    );

    return { content: data, totalItems: response.data.value.totalItems };
  } catch (error) {
    throw error;
  }
}
